import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import { updateFundSubscriptionBySubscriptionId } from './Data/subscriptions.js'
import EmailSubscriptionCenterModal from './EmailSubscriptionCenterModal.jsx'

function CategorySubscriptionButton(props) {
  const {
    subscriptionProfile,
    handleClicked,
    buttonNotClickedText,
    buttonClickedText,
    productSubscribe,
  } = props
  const [showModal, setShowModal] = useState(false)

  const [categorySubscription, setCategorySubscription] = useState(
    props.categorySubscription
  )

  const handleCloseModalClick = () => {
    setShowModal(false)
    window.location.reload()
  }

  const handleSingleSubscribeClicked = async (event) => {
    event.persist()
    const _categorySubscription = { ...categorySubscription }
    if (isLoggedIntoSubscriptionCenter()) {
      _categorySubscription.selected =
        event.currentTarget.dataset.unsubscribe !== 'true'
      _categorySubscription.checked = _categorySubscription.selected
      updateFundSubscriptionBySubscriptionId(
        subscriptionProfile,
        _categorySubscription.id,
        _categorySubscription.selected
      )
      setCategorySubscription(_categorySubscription)
    } else {
      _categorySubscription.selected = true
      setCategorySubscription(_categorySubscription)
      setShowModal(true)
    }

    if (handleClicked) {
      handleClicked()
    }
  }

  const getNotYetSubscribedButton = (_categorySubscription) => {
    return (
      _categorySubscription && (
        <button
          onClick={handleSingleSubscribeClicked}
          className={`Button Button--tertiary Button--reversed ${
            productSubscribe
              ? 'product-subscribe'
              : 'u-borderColorReversedLight'
          } u-marginRight2gu u-paddingHoriz6gu u-marginTop1gu u-md-marginRight0 u-md-marginTop0 u-paddingLeft0 u-sm-marginRight0 u-sm-marginTop0 u-sm-paddingHoriz0gu u-sm-sizeFull`}
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(
            _categorySubscription.category
          )}
          data-analytics-product={_categorySubscription.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <i className="adel-material-symbols u-marginRight1gu u-textSizeMsrp2">
            mail_outline
          </i>
          {buttonNotClickedText}
        </button>
      )
    )
  }

  const getSubscribedButton = (_categorySubscription) => {
    return (
      _categorySubscription && (
        <button
          onClick={handleSingleSubscribeClicked}
          data-unsubscribe="true"
          className={`Button Button--tertiary Button--reversed ${
            productSubscribe
              ? 'product-subscribe'
              : 'u-borderColorReversedLight'
          } u-marginRight2gu u-marginTop1gu u-md-marginRight0 u-md-marginTop0 u-paddingHoriz6gu u-paddingLeft0 u-sm-marginRight0 u-sm-marginTop0 u-sm-paddingHoriz0gu u-sm-sizeFull`}
          data-analytics-product-type="Insights"
          data-analytics-category={analyticsSwapAuthor(
            _categorySubscription.category
          )}
          data-analytics-product={_categorySubscription.name}
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
        >
          <span className="adel-material-symbols u-marginRight1gu u-textSizeMsrp2 u-posRelative">
            mail_outline
            <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon">
              check
            </span>
          </span>
          {buttonClickedText}
        </button>
      )
    )
  }

  const getSubscriptions = () => {
    const subs = JSON.parse(JSON.stringify([categorySubscription]))
    subs[0].checked = true
    return subs
  }

  const analyticsSwapAuthor = (category) => {
    return category === 'Author' ? 'Authors' : category
  }

  return (
    <>
      {showModal && (
        <EmailSubscriptionCenterModal
          subscriptions={getSubscriptions()}
          isLoggedIn={isLoggedIntoSubscriptionCenter()}
          handleCloseModalClick={handleCloseModalClick}
        />
      )}

      {categorySubscription && categorySubscription.checked
        ? getSubscribedButton(categorySubscription)
        : getNotYetSubscribedButton(categorySubscription)}
    </>
  )
}

CategorySubscriptionButton.propTypes = {
  useUnlabeledButton: PropTypes.bool,
  useInlineButton: PropTypes.bool,
  subscriptionProfile: PropTypes.object,
  handleClicked: PropTypes.func,
}

export default CategorySubscriptionButton
